export const CopyTypes = {
  MELODICLOOP: 'melodic_loop',
  DRUMLOOP: 'drum_loop',
  MELODICSTEM: 'melodic_stem',
  AUDIOSTEM: 'audio_stem',
  DRUMSTEM: 'drum_stem',
  CLIP: 'clip',
  CLIPS: 'clips'
}
